import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import matchSorter from "match-sorter";

import * as modalActions from "../../actions/modalActions";
import * as projectActions from "../../actions/projectActions";
import * as contractActions from "../../actions/contractActions";
import * as codeActions from "../../actions/codeActions";
import * as customerActions from "../../actions/customerActions";
import * as departmentActions from "../../actions/departmentActions";
import * as userActions from "../../actions/userActions";

import ProjectList from "../project/ProjectList";
import ProjectForm from "../project/ProjectForm";
import HeaderWrapper from "../common/HeaderWrapper";
import Modal from "../common/Modal";
import ConfirmModal from "../common/ConfirmModal";

class ContractProjectsPage extends Component {
  constructor(props) {
    super(props);
    this.state = { search: "", project: {}, favorites: [], adding: false };
  }

  componentDidMount = () => {
    const { users, departments, match, actions } = this.props;

    if (!users.length) actions.loadUsers();
    if (!departments.length) actions.loadDepartments();

    actions.getContract(match.params.id);
    actions.loadProjects({ contract: match.params.id });

    this.setState({ favorites: this.props.auth.user.favorites });
  };

  onClickAdd = () => {
    this.setState({ adding: true, project: {} });
    this.props.actions.showModalSuccess("projectDetailsModal");
  };

  onClickView = (id) => {
    this.setState({ adding: false });
    this.props.actions.getProject(id, true);
  };

  onClickDelete = (id) => {
    this.props.actions.requestProjectId(id);
  };

  onClickFavorite = (projectId) => {
    const favs = this.state.favorites;
    const doesExist = favs.find((id) => id === projectId);
    if (projectId === doesExist) {
      // if does, find it by its index and call Array.splice()
      const existingProjectId = favs.indexOf(doesExist);
      favs.splice(existingProjectId, 1);
    } else {
      favs.push(projectId); // if it doesn't add it to the array
    }

    this.props.auth.user.favorites = favs;
    this.props.actions.updateUser(this.props.auth.user, "favorite");
  };

  onClickFullViewProject = (id) => {
    this.props.history.push(`/app/projects/${id}`);
  };

  handleDelete = () => {
    this.props.actions.deleteProject(this.props.projectToDelete);
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (this.props.project !== nextProps.project) {
      this.setState({ project: nextProps.project });
    }

    if (this.props.auth !== nextProps.auth) {
      this.setState({ favorites: nextProps.auth.user.favorites });
    }

    if (
      this.props.match.params.openAddProyect &&
      parseInt(nextProps.match.params.openAddProyect) === 1 &&
      this.props.contract &&
      this.props.contract._id &&
      this.props.codes &&
      Array.isArray(this.props.codes) &&
      this.props.codes.length > 0 &&
      !this.state.adding
    ) {
      this.setState({ adding: true });
      this.props.actions.showModalSuccess("projectDetailsModal");
      this.props.history.push(
        `/app/contracts/${this.props.contract._id}/projects/0`
      );
    }
  };

  handleAdd = async (project) => {
    await this.props.actions.createProject(project, false);
    await this.props.actions.loadProjects({
      contract: this.props.match.params.id
    });
  };

  handleSave = (project) => {
    this.props.actions.updateProject(project, false);
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    let {
      contract,
      projects,
      codes,
      departments,
      users,
      auth,
      savingProject,
      isMobile
    } = this.props;
    const { project, search, adding, favorites } = this.state;

    const projectForm = (
      <ProjectForm
        project={adding ? {} : project}
        contract={contract}
        contracts={[contract]}
        customers={[contract.customer]}
        codes={codes}
        departments={departments}
        users={users}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.props.actions.hideModal}
        saving={savingProject}
        editing={auth.maxRole > 2000}
        adding={this.state.adding}
        preventEdit={auth.maxRole < 3000}
      />
    );

    projects = matchSorter(projects, search, {
      keys: [
        "name",
        "customer.name",
        "project_status.label",
        "call_type.label",
        "category.label",
        "start_date",
        "project_number"
      ]
    });

    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[{ label: contract.name }, { label: "Projects" }]}
          onClickView={this.handleEdit}
          onClickAdd={auth.maxRole > 2000 && this.onClickAdd}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <ProjectList
            clientSide
            auth={auth}
            projects={projects}
            favorites={favorites}
            search={search}
            isMobile={isMobile}
            onClickView={this.onClickView}
            onClickDelete={this.onClickDelete}
            onClickFavorite={this.onClickFavorite}
            onClickFullView={this.onClickFullViewProject}
          />
          <Modal
            id="projectDetailsModal"
            title={project.name || "Add Project"}
            body={projectForm}
            close={this.props.actions.hideModal}
          />
          <ConfirmModal
            id="projectDeleteModal"
            title="Delete Project"
            body="Are you sure you want to delete this project?"
            close={this.props.actions.hideModal}
            confirm={this.handleDelete}
          />
        </div>
      </React.Fragment>
    );
  }
}

ContractProjectsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  departments: PropTypes.array,
  match: PropTypes.object,
  projects: PropTypes.array.isRequired,
  codes: PropTypes.array.isRequired,
  projectToDelete: PropTypes.string,
  savingProject: PropTypes.bool,
  users: PropTypes.array,
  auth: PropTypes.object,
  project: PropTypes.object,
  contract: PropTypes.object,
  isMobile: PropTypes.bool,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,

    contract: state.reducers.contract,
    project: state.reducers.project,
    projects: state.reducers.projects,
    projectToDelete: state.reducers.projectToDelete,
    savingProject: state.reducers.savingProject,
    departments: state.reducers.departments,
    users: state.reducers.users,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...projectActions,
        ...contractActions,
        ...customerActions,
        ...departmentActions,
        ...userActions,
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ContractProjectsPage);
